import { z } from 'zod'

export const DestinosSchema = z.object({
  id: z.number(),
  attributes: z.object({
    slug: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    publishedAt: z.string(),
    lead: z.string(),
    hero: z.object({
      id: z.number(),
      author: z.string(),
      title: z.string(),
      image: z.object({
        data: z.object({
          attributes: z.object({
            url: z.string(),
          }),
        }),
      }),
    }),
    metadata: z.object({
      title: z.string(),
      description: z.string(),
      image: z.object({
        data: z.object({
          attributes: z.object({
            url: z.string(),
          }),
        }),
      }),
    }),
    seo_text: z.object({
      title: z.string(),
      text: z.string(),
    }),
    featured_destinations: z.array(
      z.object({
        title: z.string(),
        card: z.array(
          z.object({
            title: z.string(),
            url: z.string(),
            image: z.object({
              data: z.array(
                z.object({
                  attributes: z.object({
                    url: z.string(),
                  }),
                }),
              ),
            }),
          }),
        ),
      }),
    ),
    destination_banners: z.array(
      z.object({
        title: z.string(),
        text: z.string(),
        button: z.object({
          text: z.string(),
          url: z.string(),
        }),
        image: z.object({
          data: z.object({
            attributes: z.object({
              url: z.string(),
            }),
          }),
        }),
      }),
    ),
    sponsors: z.array(
      z.object({
        image: z.object({
          data: z.object({
            attributes: z.object({
              url: z.string(),
            }),
          }),
        }),
        alt: z.string(),
      }),
    ),
  }),
})

export type schemaType = z.infer<typeof DestinosSchema>
